const leftMenuPosition = (event, className) => {
  let bodyWidth =
    document.documentElement.offsetWidth || document.body.offsetWidth;
  let bodyHeigth =
    document.documentElement.offsetHeight || document.body.offsetHeight;

  let popoverBox = document.getElementsByClassName(className);
  let popoverWidth = popoverBox[0].offsetWidth;
  let popoverHeight = popoverBox[0].offsetHeight;

  let popover = {
    left: 0,
    top: 0,
  };

  if (event.pageX + popoverWidth < bodyWidth) {
    popover.left = event.pageX;
  } else {
    popover.left = event.pageX - popoverWidth;
  }

  if (event.pageY + popoverHeight < bodyHeigth - 30) {
    popover.top = event.pageY;
  } else {
    popover.top = event.pageY - popoverHeight;
  }

  // console.log(popover);
  return popover;
};

export { leftMenuPosition };
